import { Deserializable } from '../deserializable';
import { DooyaFiaApplication } from './dooya-fia-application';

export class FiaApplication implements Deserializable {
  public id: number;
  public userId: number;
  public requestedByUserId: number;
  public caseNumber: number;
  public requestRefNumber: string;
  public requestedFiaAmount: number;
  public accepted: boolean;
  public dateRequested: Date;
  public resubmittedDate: Date;
  public status: string;
  public pin: string;
  public pinIssueDate: Date;
  public pinExpiryDate: Date;
  public plannedInvestmentDate: Date;
  public isAutoCreated: boolean;

  public selected: boolean;
  public busy: boolean;
  public dooyaFiaApplication: DooyaFiaApplication;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
